import axios from 'axios';
import config from '../config';
import { getDataFromAccessToken, getAccessToken } from '../utils/tokens';

const reqTimeOut = 5000;

export const fetchAuth = axios.create({
  baseURL: config.baseURL,
  // baseURL: 'https://auth-stage.burninghut.ru',
  timeout: reqTimeOut,
  withCredentials: true,
});

export default {
  getApps() {
    return fetchAuth.get('/id/auth/applications');
  },

  getAppUsers(payload) {
    return fetchAuth.get(`/id/auth/users/application/${payload}`, {
      params: { page: 1, limit: 100 },
    });
  },

  removeRoles(sub, appName, roles) {
    return fetchAuth.patch(`/id/auth/users/${sub}/application/${appName}/remove`, {
      roles,
    });
  },

  addRoles(sub, appName, roles) {
    return fetchAuth.patch(`/id/auth/users/${sub}/application/${appName}/add`, {
      roles,
    });
  },

  findUsers(input) {
    return fetchAuth.get('/id/auth/find-user', {
      params: {
        page: 1,
        limit: 5,
        value: input,
      },
      headers: {
        'x-find-token': config.headerToken,
      },
    });
  },

  logIn(token) {
    const decoded = getDataFromAccessToken(config.cookieName);
    const { integer_id: integerId } = decoded['bb-auth:meta'];

    const axiosLogIn = axios.create({
      baseURL: config.baseURL,
      timeout: reqTimeOut,
      headers: {
        Authorization: `Bearer ${token}`,
        'x-auth-app': 'odin',
      },
    });
    return axiosLogIn.get(`/api/v1/users/${integerId}`);
  },

  logout: () => {
    const token = getAccessToken(config.cookieName);

    const axiosRefreshToken = axios.create({
      baseURL: config.baseURL,
      timeout: 5000,
      headers: {
        Authorization: `Bearer ${token}`,
        'x-auth-app': 'odin',
      },
      withCredentials: true,
    });

    return axiosRefreshToken.patch('/api/v1/auth/revoke-token', {}, {
      headers: {
        Authorization: `Bearer ${token}`,
        'x-auth-app': 'odin',
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/odin-api.js